// trackEvents.ts
import posthog from './posthog'

/**
 * Track events to PostHog
 */
export const trackEvent = (eventName: string, properties: Record<string, any> = {}) => {
  try {
    posthog.capture(eventName, properties)
  } catch (error: any) {
    console.error(`Error tracking event ${eventName}:`, error)
  }
}

/**
 * Identify user in PostHog
 */
export const identifyUser = (userId: string, userProperties: Record<string, any> = {}) => {
  try {
    posthog.identify(userId, userProperties)
  } catch (error: any) {
    console.error(`Error identifying user ${userId}:`, error)
  }
}
